import React from 'react'
import "./Description.scss";

const Description = () => (
  <div className="description-container">
    {/* <h2>רוצים להמשיך לקרוא?</h2> */}
    <h3>סקרנים? מצוין!</h3>
    <h4>
      לקריאת הכתבה מלאו את פרטיכם מטה.       
    </h4>
    {/*<h4>*/}
    {/*  מתכני */}
    {/*  <span className='ynet-p'></span>*/}
    {/*  מלאו את פרטיכם מטה.*/}
    {/*</h4>    */}
  </div>
);

export default Description
